import './style.css'

import * as c from '@chakra-ui/react'
import React from 'react'
import { Autoplay, Navigation, Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react'

import { ArrowLeftIcon } from '../icons/arrow-left.icon'
import { ArrowRightIcon } from '../icons/arrow-right.icon'

interface CarouselProps<T> {
  slidesPerView?: number
  spaceBetween?: number
  hasAutoplay?: boolean
  hasLastCard?: React.ComponentType
  data: T[]
  Content: React.ComponentType<{ data: T }>
}

export default function Carousel<T>({
  slidesPerView = 1,
  spaceBetween = 12,
  hasAutoplay = false,
  hasLastCard,
  data = [],
  Content,
}: CarouselProps<T>) {
  const modules = hasAutoplay
    ? [Pagination, Navigation, Autoplay]
    : [Pagination, Navigation]

  return (
    <Swiper
      slidesPerView={slidesPerView}
      spaceBetween={spaceBetween}
      pagination={{
        el: '.swiper-pagination',
        clickable: true,
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active',
      }}
      navigation={{
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
      }}
      autoplay={{
        delay: 9000,
      }}
      modules={modules}
    >
      {data?.map((item, i) => (
        <SwiperSlide key={i}>{Content && <Content data={item} />}</SwiperSlide>
      ))}
      {hasLastCard && <SwiperSlide>{hasLastCard}</SwiperSlide>}

      <NavigationButtons />
    </Swiper>
  )
}

function NavigationButtons() {
  return (
    <c.Flex mt="s5" mx="auto" justify={['space-between', 'space-evenly']}>
      <c.Button
        className="swiper-button-prev"
        size="xs"
        variant="light"
        h="24px"
        bg={['black.0', 'black.100']}
        _focus={{
          border: 'none',
        }}
      >
        <c.Icon as={ArrowLeftIcon} color="black.500" h="" w="" />
      </c.Button>

      <c.Box className="swiper-pagination" maxW="fit-content" />

      <c.Button
        className="swiper-button-next"
        size="xs"
        variant="light"
        h="24px"
        bg={['black.0', 'black.100']}
        _focus={{
          border: 'none',
        }}
      >
        <c.Icon as={ArrowRightIcon} color="black.500" h="" w="" />
      </c.Button>
    </c.Flex>
  )
}
